<div *ngIf="alumno$ | async as alumno">
    <div *ngFor="let criterio of criterios; let i = index">
        <app-retroalimentacion-nivel-trabajo-criterios view="trabajo" [criterio]="criterio" [fecha$]="fechaActual$"
        [eventoUnidadId]="eventoUnidadId" [alumno]="alumno" [alumnos$]="alumnos$" [index]="i" [mostrarAutoevaluacion$]="mostrarAutoevaluacion$">
          </app-retroalimentacion-nivel-trabajo-criterios>
    </div>
</div>
